export default "__VITE_ASSET__DXa8zsis__"